<template>
	<div class="content-advance-search">
		<div class="content-search">
			<b-container fluid="xl">
				<div class="wrap-input-search">
					<b-form-input
						class="input-search"
						:class="{ 'active-suggest': isSuggest && suggestList.length }"
						:placeholder="$t('search.search')"
						v-model="search_params.search"
						@blur="handleSearchBlur"
						@focus="isSuggest = true"
					></b-form-input>
					<MagnifyIcon class="icon-search" />
					<ul
						ref="suggest"
						class="suggest-search"
						v-if="suggestList.length && isSuggest"
					>
						<li
							@click="searchSuggest(item)"
							v-for="(item, index) in suggestList"
							:key="index"
						>
							{{ item }}
						</li>
					</ul>
				</div>
				<div class="wrap-chose">
					<div class="title-tooltip-left">{{ $t('packages.type') }}</div>
					<b-dropdown no-flip
						class="input-choose"
						:disabled="jobType.isCheck ? true : false"
					>
						<template v-slot:button-content>
							<span>
								{{ packageItem ? packageItem.value : $t('packages.type') }}
								<ChevronDownIcon />
							</span>
						</template>
						<b-dropdown-item @click="handlePackageType(null)">
							{{ $t('packages.type') }}
						</b-dropdown-item>
						<b-dropdown-item
							@click="handlePackageType(item)"
							v-for="(item, index) in packageType"
							:key="index"
							value="item.value"
						>
							{{ $t(item.text) }}
						</b-dropdown-item>
					</b-dropdown>
				</div>
				<div class="category-treeview">
					<div class="title-tooltip-left">{{ $t('category') }}</div>
					<div class="control_wrapper">
						<b-card
							v-for="(catagory, index) in categoriesOptions"
							:key="index"
							no-body
							class="mb-1"
						>
							<div class="d-flex align-items-center">
								<b-form-checkbox
									:class="'checkbox_parent_' + index + catagory.id"
									v-model="allSelected['catagory_' + catagory.id]"
								></b-form-checkbox>
								<b-button v-b-toggle="'accordion-' + index" variant="primary">
									<span>{{ $t(catagory.description) }}</span>
									<span class="when-opened">
										<ChevronUpIcon />
									</span>
									<span class="when-closed">
										<ChevronDownIcon />
									</span>
								</b-button>
							</div>

							<b-collapse :id="'accordion-' + index">
								<div class="ml-4">
									<div
										v-for="(item, key) in catagory.listing_category_children"
										:key="key"
										class="d-flex align-items-center"
									>
										<b-form-checkbox
											:value="item.id"
											v-model="catagoryCheck['catagory_' + catagory.id]"
										></b-form-checkbox>
										<b-button variant="primary">
											<span>{{ $t(item.description) }}</span>
										</b-button>
									</div>
								</div>
							</b-collapse>
						</b-card>
					</div>
				</div>
				<div>
					<template>
						<div class="wrap-input" v-if="attributes.bedRoom">
							<div class="title-tooltip-left">
								{{ $t('addListing.details.bedroom') }}
							</div>
							<b-form-input
								:placeholder="$t('addListing.details.numBedroom')"
								v-model="listing_attributes.bedroom.value"
							></b-form-input>
						</div>
						<div class="wrap-input" v-if="attributes.bathRoom">
							<div class="title-tooltip-left">
								{{ $t('addListing.details.bathroom') }}
							</div>
							<b-form-input
								:placeholder="$t('addListing.details.numBathroom')"
								v-model="listing_attributes.bathroom.value"
							></b-form-input>
						</div>
						<div class="wrap-chose" v-if="attributes.saleRent">
							<div class="title-tooltip-left">
								{{ $t('addListing.details.saleRent') }}
							</div>
							<b-dropdown no-flip
								class="input-choose mt-10"
								:disabled="saleOrRent.isCheck ? true : false"
							>
								<template v-slot:button-content>
									<span>
										{{ saleOrRentItem ? $t(saleOrRentItem.value) : $t('addListing.details.rent') }}
										<ChevronDownIcon />
									</span>
								</template>
								<b-dropdown-item
									@click.native="getItemSaleOrRent(attr)"
									v-for="(attr, i) in saleOrRent.attr"
									:key="i"
									:value="attr.id"
								>
									{{ $t(attr.value) }}
								</b-dropdown-item>
							</b-dropdown>
						</div>
					</template>
					<template>
						<div class="wrap-input" v-if="attributes.brand">
							<div class="title-tooltip-left">
								{{ $t('addListing.details.brand') }}
							</div>
							<b-form-input
								:placeholder="$t('addListing.details.carBrand')"
								v-model="listing_attributes.brand.value"
							></b-form-input>
						</div>
						<div class="wrap-input" v-if="attributes.year">
							<div class="title-tooltip-left">
								{{ $t('addListing.details.year') }}
							</div>
							<b-form-input
								:placeholder="$t('addListing.details.year')"
								v-model="listing_attributes.year.value"
							></b-form-input>
						</div>
						<div class="wrap-chose" v-if="attributes.gearType">
							<div class="title-tooltip-left">
								{{ $t('addListing.details.gearType') }}
							</div>
							<b-dropdown no-flip
								class="input-choose"
								:disabled="gearType.isCheck ? true : false"
							>
								<template v-slot:button-content>
									<span>
										{{
											gearTypeItem
												? $t(gearTypeItem.value)
												: $t('addListing.details.typeOfGear')
										}}
										<ChevronDownIcon />
									</span>
								</template>
								<b-dropdown-item
									@click.native="getItemGearType(data)"
									v-for="(data, i) in gearType.attr"
									:key="i"
									:value="data.id"
								>
									{{ $t(data.value) }}
								</b-dropdown-item>
							</b-dropdown>
						</div>
						<div class="wrap-input" v-if="attributes.year">
							<div class="title-tooltip-left">
								{{ $t('addListing.details.colorType') }}
							</div>
							<b-form-input
								:placeholder="$t('addListing.details.carColor')"
								v-model="listing_attributes.color.value"
							></b-form-input>
						</div>
						<div class="wrap-input" v-if="attributes.Mileage">
							<div class="title-tooltip-left">
								{{ $t('addListing.details.milage') }}
							</div>
							<b-form-input
								:placeholder="$t('addListing.details.milage')"
								v-model="listing_attributes.mileage.value"
							></b-form-input>
						</div>
					</template>
					<template>
						<div class="wrap-chose" v-if="attributes.jobType">
							<div class="title-tooltip-left">
								{{ $t('addListing.details.jobType') }}
							</div>
							<b-dropdown no-flip
								class="input-choose"
								:disabled="jobType.isCheck ? true : false"
							>
								<template v-slot:button-content>
									<span>
										{{ jobTypeItem ? $t(jobTypeItem.value) : $t('all') }}
										<ChevronDownIcon />
									</span>
								</template>
								<b-dropdown-item
									@click.native="getItemJobType(data)"
									v-for="(data, i) in jobType.attr"
									:key="i"
									:value="data.id"
								>
									{{ $t(data.value) }}
								</b-dropdown-item>
							</b-dropdown>
						</div>
						<div class="wrap-input" v-if="attributes.salary">
							<div class="title-tooltip-left">
								{{ $t('addListing.details.salary') }}
							</div>
							<b-form-input
								type="number"
								:placeholder="$t('search.minimum')"
								v-model="search_params.minimum_salary"
							></b-form-input>
							<b-form-input
								type="number"
								class="mt-10"
								:placeholder="$t('search.maximum')"
								v-model="search_params.maximum_salary"
							></b-form-input>
						</div>
					</template>
					<template>
						<div v-if="attributes.price" class="wrap-price-range">
							<div class="title-tooltip-left">
								{{ $t('search.priceRange') }}
							</div>
							<b-form-input
								class="price-range-input"
								type="number"
								:placeholder="$t('search.minimum')"
								v-model="search_params.minimum_price"
							></b-form-input>
							<b-form-input
								class="price-range-input"
								type="number"
								:placeholder="$t('search.maximum')"
								v-model="search_params.maximum_price"
							></b-form-input>
						</div>
						<div class="wrap-chose-area">
							<div class="title-tooltip-left">{{ $t('search.area') }}</div>
							<b-dropdown class="input-choose">
								<template v-slot:button-content>
									<span>
										{{
											provinceName != null
												? $t(provinceName.name)
												: $t('search.allProvinces')
										}}
										<ChevronDownIcon />
									</span>
								</template>
								<b-dropdown-item @click="getItemProvince(null)">
									{{ $t('all') }}
								</b-dropdown-item>
								<b-dropdown-item
									@click.native="getItemProvince(province)"
									v-for="(province, i) in provinces"
									:key="i"
									:value="province.id"
								>
									{{ $t(province.name) }}
								</b-dropdown-item>
							</b-dropdown>
							<b-dropdown no-flip
								class="input-choose mt-10"
								:disabled="provinceName != null ? false : true"
							>
								<template v-slot:button-content>
									<span>
										{{
											districtName != null
												? $t(districtName.name)
												: $t('search.allDistricts')
										}}
										<ChevronDownIcon />
									</span>
								</template>
								<b-dropdown-item @click="getItemDistrict(null)">
									{{ $t('all') }}
								</b-dropdown-item>
								<b-dropdown-item
									@click.native="getItemDistrict(data)"
									v-for="(data, i) in arrListDistrict"
									:key="i"
									:value="data.id"
								>
									{{ $t(data.name) }}
								</b-dropdown-item>
							</b-dropdown>
						</div>
						<div class="wrap-chose-condition" v-if="attributes.condition">
							<div class="title-tooltip-left">{{ $t('search.condition') }}</div>
							<b-dropdown no-flip
								class="input-choose"
								:disabled="condition.isCheck ? true : false"
							>
								<template v-slot:button-content>
									<span>
										{{ conditionItem ? $t(conditionItem.value) : $t('all') }}
										<ChevronDownIcon />
									</span>
								</template>
								<b-dropdown-item
									@click.native="getItemCondition(attr)"
									v-for="(attr, i) in condition.attr"
									:key="i"
									:value="attr"
								>
									{{ $t(attr.value) }}
								</b-dropdown-item>
							</b-dropdown>
						</div>
						<div class="wrap-btn">
							<b-button
								id="searchAndRedirect"
								@click="searchAndRedirect()"
								class="btn-advance-search"
							>
								{{$t('search.start searching')}}
							</b-button>
						</div>
					</template>
				</div>
			</b-container>
		</div>
	</div>
</template>

<script>
import SearchDesktop from '@/components/search/SearchDesktop';
// Icons
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';
import ChevronUpIcon from 'vue-material-design-icons/ChevronUp.vue';
import MagnifyIcon from 'vue-material-design-icons/Magnify.vue';

export default {
	extends: SearchDesktop,
	components: {
		ChevronDownIcon,
		ChevronUpIcon,
		MagnifyIcon
	},
	data() {
		return {
			loading:true
		}
	},
	methods: {
		searchAndRedirect() {
			let prms = { ...this.search_params };
			let text = this.searchTitle;
			this.$store.commit('CategoryController/SET_TITLE_SEARCH', text);
			this.GET_DATA_SEARCH_CATEGORY(prms).then(result => {
				
				this.$router.push({
					path: this.$i18nRoute({ name: 'search' }),
					query: {
						plan: 'mobile',
						categories: this.search_params.listing_category_ids
					}
				});
			});
		}
	}
};
</script>
<style lang="scss">
@import 'searchMobile.scss';
</style>
